<template>
<div id="mai-chat" >
  <div class="row">
    <div class="col-xs-12 topic">
      <i class="fa fa-comments"></i>
      {{ topicName || 'Mai Chat' }}
    </div>
  </div>
  <main :class="'active'">
    <div class="scroll clearfix">
      <conversation :messages="conversations" :userId="1" v-if="viewing === 'conversation'" @send-action="sendAction" />
    </div>
  </main>
  <footer v-show="open">
    <div v-if="viewing === 'conversation'" class="send-message">
      <textarea @blur="setFocus" @keyup.enter="sendMessage" class="chat-search" :placeholder="'Type Message'" v-model="message" ref="cm"></textarea>
      <el-upload
        v-show="uploadToggle"
        class="upload-demo"
        :on-change="handleSuccess"
        :on-remove="handleRemove"
        :limit="1"
        :file-list="fileList"
        ref="upload"
        action="https://jsonplaceholder.typicode.com/posts/"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary" ref="btnUpload" style="display: none">select file</el-button>
      </el-upload>
      <div class="action-btn clearfix">
        <div class="pull-left flex flex-middle text-to-speech-container">
          <el-switch
            v-model="speech"
            inactive-color="#ff4949"
            active-color="#13ce66"
            active-text="Speech">
          </el-switch>
        </div>
        <div class="pull-right">
          <el-button-group>
            <el-button ref="speakIcon" icon="fa fa-microphone" @click="speak"></el-button>
            <el-button :type="uploadToggle ? 'success' : ''" icon="el-icon-upload" @click="checkupload"></el-button>
            <el-button type="primary" @click="sendMessage" :disabled="!message"><i class="fa fa-paper-plane menu-icon"></i> Send</el-button>
          </el-button-group>
        </div>
      </div>
    </div>
  </footer>
</div>
</template>
<script>
import Contacts from './ChatContacts'
import Conversation from './ChatConversation'
import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'
import api from '@/api'
import config from '../../config'
import Time from '@/mixins/Time'
export default {
  name: 'MaiChat',
  mixins: [ Time ],
  props: {
    participants: {
      type: Array,
      required: true
    },
    caseInfo: {
      type: Object,
      required: true
    },
    userInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    Contacts,
    Conversation
  },
  data () {
    return {
      open: true,
      stompClient: null,
      viewing: 'conversation',
      speech: false,
      message: '',
      username: '',
      topic: '',
      topicName: '',
      name: '',
      uploadToggle: false,
      contacts: [],
      conversations: [],
      demo: [],
      fileList: [],
      fileUploadList: [],
      tenantId: null,
      caseId: null,
      isMaia: false,
      role: null,
      id: 1,
      dimensions: {
        bottom: 250,
        right: 250
      },
      initial: {
        x: null,
        y: null
      },
      end: {
        x: null,
        y: null
      }
    }
  },
  computed: {
    bottom () {
      return `${this.dimensions.bottom}px`
    },
    right () {
      return `${this.dimensions.right}px`
    }
  },
  methods: {
    connect () {
      this.$http.get(api.SESSION_TOKEN)
        .then(({data}) => {
          let socket = new SockJS(`${config.serverWebSocketUrl}?tk=${data}`)
          this.stompClient = Stomp.over(socket)
          this.stompClient.connect({}, this.onConnected, this.onError)
        })
        .catch(console.log)
    },
    onConnected () {
      this.stompClient.subscribe('/topic/' + this.topic, this.onMessageReceived)
      this.stompClient.subscribe('/topic/user-connected', this.onUserConnected)
      this.stompClient.subscribe('/topic/user-disconnected', this.onUserDisconnected)
      this.stompClient.send('/app/chat.userjoined/' + this.topic, JSON.stringify({sender: this.username, type: 'JOIN', topic: this.topic, tenantId: this.tenantId}), {})
      this.participants.forEach((participant) => {
        if (participant.username === this.username) {
          participant.active = true
        }
      })
    },
    onError (err) {
      this.$alert(err, 'An error occurred', {confirmButtonText: 'OK'})
    },
    onMessageReceived (payload) {
      let message = JSON.parse(payload.body)
      if (message.type === 'JOIN') {
        this.topicName = message.subject + ': ' + message.topicName
        if (message.sender.maiUserId === this.username) {
          message.participants.forEach((participant) => {
            if (participant.id === 'maia' || participant.name.toLowerCase() === 'maia') {
              this.isMaia = true
              this.participants.push({...participant, online: true})
            } else if (participant.id !== this.username) {
              this.participants.push(participant)
            }
          })
          message.conversations.forEach((conversation) => {
            if (conversation.sender.maiUserId === this.username) {
              this.postMessage(conversation.messageType, conversation.content, this.username, 1, 2, conversation.files, conversation.sender.name, conversation.created)
            } else {
              this.postMessage(conversation.messageType, conversation.content, conversation.sender, 2, 1, conversation.files, conversation.sender.name, conversation.created)
            }
          })
        }
      } else {
        if (!this.speech && message.sender.maiUserId === 'maia') { this.speakText(message.text) }
        if (this.username === message.sender.maiUserId) {
          this.postMessage(message.messageType, message.content, message.sender.maiUserId, 1, 2, message.files, message.sender.name, message.created)
        } else {
          this.postMessage(message.messageType, message.content, message.sender.maiUserId, 2, 1, message.files, message.sender.name, message.created)
        }
      }
    },
    onUserConnected (payload) {
      let userId = String(payload.body)
      this.participants.forEach((participant) => { if (participant.maiUserId === userId) { participant.online = true } })
    },
    onUserDisconnected (payload) {
      let userId = String(payload.body)
      this.participants.forEach((participant) => { if (participant.maiUserId === userId) { participant.online = false } })
    },
    sendMessage () {
      if ((this.message || this.fileUploadList.length > 0) && this.stompClient) {
        let chatMessage = {
          sender: {maiUserId: this.username, name: this.userInfo.fullname},
          topic: this.topic,
          content: this.message.trim(),
          type: 'CHAT',
          files: this.fileUploadList,
          tenantId: this.tenantId,
          caseDetailId: this.caseId,
          role: this.role
        }
        this.stompClient.send('/app/chat.sendMessage/' + this.topic, JSON.stringify(chatMessage))
        if (this.isMaia) {
          this.stompClient.send('/app/chat.sendMessageToBot/' + this.topic, JSON.stringify(chatMessage))
        }
        this.uploadToggle = false
        this.fileUploadList = []
        this.fileList = []
        this.message = ''
      }
      event.preventDefault()
    },
    postMessage (componentType, content, sender, from, to, files, fullname, datetime) {
      this.conversations.push(
        { componentType, from, to, name: fullname, content, time: datetime, files }
      )
    },
    speak () {
      if (window.hasOwnProperty('webkitSpeechRecognition')) {
        // eslint-disable-next-line
        let recognition = new webkitSpeechRecognition();
        recognition.continuous = false
        recognition.interimResults = false
        recognition.lang = 'en-US'
        recognition.start()
        let maichat = this
        recognition.onstart = function () {
          maichat.$refs.cm.placeholder = 'Speak'
          maichat.$refs.speakIcon.type = 'danger'
        }

        recognition.onresult = function (event) {
          let transcript = ''
          let maxSize = event.results.length
          for (let i = 0; i < maxSize; i++) {
            transcript += event.results[i][0].transcript
          }
          maichat.message = transcript
          maichat.$refs.cm.placeholder = 'Type Message'
          recognition.stop()
        }

        recognition.onerror = function (event) {
          recognition.stop()
          console.log(event.error)
        }
      }
    },
    checkupload () {
      this.uploadToggle = !this.uploadToggle
    },
    handleSuccess (file) {
      let maichat = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', file.url, true)
      xhr.responseType = 'blob'
      xhr.onload = function (e) {
        if (this.status === 200) {
          maichat.generateBase64(this.response, file)
        }
      }
      xhr.send()
    },
    generateBase64 (response, file) {
      let maichat = this
      let reader = new FileReader()
      reader.readAsDataURL(response)
      reader.onloadend = function () {
        let base64data = reader.result
        maichat.fileUploadList.push({meta: {name: file.name, size: file.size, uid: file.uid}, base64: base64data})
      }
    },
    handleRemove () {
      this.fileUploadList = []
      this.uploadToggle = false
    },
    getUser () {
      return new Promise((resolve, reject) => {
        this.$http.get(api.LOGGED_IN_USER_INFO, {})
          .then(({data}) => {
            resolve(data)
          }).catch(reject)
      })
    },
    getCaseInfo () {
      this.$http.get(api.CASE + '/' + this.caseId, { params: { tenantId: this.tenantId } })
        .then(({data}) => {
          this.caseInfo.id = data.caseReference
          this.caseInfo.name = data.firstName + ' ' + data.lastName
          this.caseInfo.type = data.caseType.name
          this.caseInfo.assignment = data.policy.name
          this.caseInfo.location = data.hostLocation.name
        }).catch(console.log)
    },
    setFocus () {
      this.$refs.cm.focus()
    },
    speakText (text) {
      try {
        if (window.speechSynthesis) {
          let u = new SpeechSynthesisUtterance(text)
          let voices = window.speechSynthesis.getVoices()
          u.voice = voices.filter(function (voice) {
            return voice.name === 'Google UK English Female'
          })[0]

          let chunkLength = 160
          let pattRegex = new RegExp('^[\\s\\S]{' + Math.floor(chunkLength / 2) + ',' + chunkLength + '}[.!?,]{1}|^[\\s\\S]{1,' + chunkLength + '}$|^[\\s\\S]{1,' + chunkLength + '} ')

          let arr = []
          while (text.length > 0) {
            arr.push(text.match(pattRegex)[0])
            text = text.substring(arr[arr.length - 1].length)
          }
          arr.forEach(a => {
            let utter = new SpeechSynthesisUtterance(a.trim())
            utter.voice = u.voice
            window.speechSynthesis.speak(utter)
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    isJsonString (str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    hasImage (carousel) {
      carousel.forEach(item => {
        if (item.image_url !== null) {
          return true
        }
      })
      return false
    },
    sendAction (action) {
      this.message = action
      this.sendMessage()
    }
  },
  mounted () {
    this.topic = this.$route.query.topic
    localStorage.setItem('token', this.$route.query.t)
    this.tenantId = this.$route.query.tenant
    this.$emit('has-tenant-id', this.tenantId)
    this.caseId = this.$route.query.case
    if (this.caseId) {
      this.getCaseInfo()
    }
    this.getUser().then(data => {
      this.username = data.id
      this.role = data.role
      if (data.firstName && data.lastName) {
        this.userInfo.fullname = data.firstName + ' ' + data.lastName
      } else {
        this.userInfo.fullname = data.userlogin
      }
    }).finally(this.connect)
    this.speakText('')
  },
  watch: {
    uploadToggle (newVal) {
      if (newVal) {
        this.$refs.btnUpload.$el.click()
      }
    },
    viewing (newVal, oldVal) {
      this.conversations = [ ...this.demo ]
      this.message = ''
    }
  }
}
</script>
<style lang="scss">
#mai-chat {
  .action-btn {
    position: relative;
    height: auto;
    margin-top: 5px;

    .text-to-speech-container {
      height: 40px;
    }
  }
  .btn {
    padding: 10px 25px;
    font-size: 1.5em;
    border-radius: 4px;
  }

  input[type="file"] {
    display: none;
  }
  .chat-search {
    background: transparent;
    font-size: 16px;
    color: #000000;
    border: none;
    outline: none;
    border: 1px solid #d1d1d1;
    width: 100%;
    padding: 10px;
    &::placeholder {
      color: #e5e5e5;
    }
  }
  z-index: 0;
  footer {
    border-right: 1px solid #d1d1d1;
    border-left: 1px solid #d1d1d1;
    border-bottom: 1px solid #d1d1d1;
    background: #fff;
    padding: 10px;
    color: #fff;
  }
  main {
    max-height: 0;
    transition: max-height 0.3s;
    overflow: hidden;
    background: #fff;
    border: 1px solid #d1d1d1;
    &.active {
      height: 100%;
      max-height: 70vh;
      min-height: 500px;
      overflow: auto;
    }
  }
  .btn-close {
    font-size: 20px;
  }
  .topic {
    font-size: 1.8em;
    font-weight: bold;
    color: #0ea4f1;
    padding-bottom: 10px;
  }
  .speech-container {
    padding-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/MaiChat.vue